import { Box, IconButton, Stack, Typography } from '@mui/joy';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { motion, useReducedMotion } from 'framer-motion';

export function AvailabilityCoverageLegend({ resource, includesOwn }) {
    const { data, error, loading, refresh } = resource;
    return <Box sx={{ pb: 0.5, px: 0.25 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'var(--joy-palette-text-primary)' }}>Фотографы по всем точкам</Typography>
            <IconButton size="sm" variant="plain" onClick={refresh} disabled={loading}
                aria-label="Обновить количество фотографов" title="Обновить количество фотографов"
                sx={{ minWidth: 44, minHeight: 44, flexShrink: 0, color: '#c56ffa',
                    '@keyframes coverage-spin': { to: { transform: 'rotate(360deg)' } },
                    '& svg': { animation: loading ? 'coverage-spin 1s linear infinite' : 'none' },
                    '@media (prefers-reduced-motion: reduce)': { '& svg': { animation: 'none' } } }}>
                <RefreshRoundedIcon sx={{ fontSize: 21, color: 'inherit' }} />
            </IconButton>
        </Stack>
        <Typography sx={{ fontSize: 12, color: 'var(--joy-palette-text-secondary)', lineHeight: 1.5 }}>
            Админы-фотографы включены.{includesOwn ? ' Твой выбор виден другим после сохранения.' : ' Учитываются сохранённые дни доступности.'}
        </Typography>
        <Box role="status" aria-live="polite" sx={{ minHeight: 20, mt: 0.5 }}>
            <Typography sx={{ fontSize: 12, lineHeight: '20px', color: error && !loading ? '#f5b942' : 'var(--joy-palette-text-secondary)' }}>
                {loading ? (data ? 'Обновляем количество…' : 'Загружаем количество…')
                    : error ? `${error}${data ? ' Показаны последние данные.' : ''}`
                        : 'Обновление каждые 30 секунд'}
            </Typography>
        </Box>
    </Box>;
}

export function AvailabilityDayCoverage({ date, row, viewerGroup, available, stale = false }) {
    const reduced = useReducedMotion();
    const includesOwn = viewerGroup === 'photographers' && available;
    const count = row ? row.photographers + (includesOwn ? 1 : 0) : null;
    return <Box data-coverage-date={date} data-coverage-group="photographers" role="img"
        aria-label={`Фотографы: ${count === null ? 'данные недоступны' : count}${stale ? ', последние данные' : ''}`}
        title={`Доступно фотографов: ${count === null ? 'нет данных' : count}${includesOwn && row ? ', включая тебя' : ''}`}
        sx={{ display: 'inline-flex', gap: 0.5, alignItems: 'center', justifyContent: 'center',
            minWidth: 48, minHeight: 32, px: 0.75, boxSizing: 'border-box', borderRadius: 8,
            bgcolor: 'rgba(162,38,226,.13)', border: '1px solid rgba(197,111,250,.3)', color: '#dbb2ff', opacity: stale ? 0.75 : 1 }}>
        <CameraAltRoundedIcon aria-hidden="true" sx={{ fontSize: 15, color: 'inherit' }} />
        <motion.span key={count === null ? 'unavailable' : count} aria-hidden="true"
            initial={reduced ? false : { opacity: 0.5, y: 2 }} animate={{ opacity: 1, y: 0 }}
            transition={{ duration: reduced ? 0 : 0.16 }}
            style={{ display: 'inline-block', minWidth: '1ch', textAlign: 'center', fontSize: 14, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
            {count === null ? '—' : count}
        </motion.span>
    </Box>;
}
